










import { Component, Vue } from 'vue-property-decorator'
import { primaryColor } from '@/plugins/vuetify'
import { tokensDeTema } from '@/shareds/novidades/tema'

/**
 * Raiz das telas de Novidades: põe as variáveis de cor (tema e marca do tenant) e a altura da barra
 * do topo, que o índice e a rolagem descontam.
 */
@Component
export default class RaizDeNovidades extends Vue {
	get escuro() {
		return this.$vuetify.theme.dark
	}

	get tokens() {
		return {
			...tokensDeTema(primaryColor(), this.escuro),
			'--nov-topo': `${this.$vuetify.application.top}px`,
		}
	}
}
